import { Component, OnInit, Input } from '@angular/core';
import {OptionsNgxOwCarouselService} from 'dmmp-services';

@Component({
  selector: 'dmmp-images-event-carousel',
  templateUrl: './images-event-carousel.component.html'
})
export class ImagesEventCarouselComponent implements OnInit {

  constructor(private options: OptionsNgxOwCarouselService) { }

  @Input() data
  @Input() identifier
  configBenefits;

  ngOnInit() {
    this.configBenefits = this.options.configurationBenefits(this.data);
  }

}
